import {OffsetModifier} from '@popperjs/core/lib/modifiers/offset';

/**
 * Popper modifier, default offset for a dropdown component
 */
export const createPopperDropdownOffsetModifier = (): OffsetModifier => ({
    name: 'offset',
    options: {
        offset: [0, 4]
    }
} as OffsetModifier);
